export default __webpack_public_path__ + "static/media/logo.a16a51a8.png";